import { render, staticRenderFns } from "./Associated.vue?vue&type=template&id=10e6a03c&scoped=true&"
import script from "./Associated.vue?vue&type=script&lang=ts&"
export * from "./Associated.vue?vue&type=script&lang=ts&"
import style0 from "./Associated.vue?vue&type=style&index=0&id=10e6a03c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6a03c",
  null
  
)

component.options.__file = "Associated.vue"
export default component.exports